import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { contractStatusesApiSchema } from '../../models';

const contractOptionsApi = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}/contract/options` }));

export const fetchContractStatuses = async ({ signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await contractOptionsApi.get('contract-statuses', { signal }).json(contractStatusesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on contract statuses response',
        (error as ValiError<typeof contractStatusesApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
